import { Flex } from "@eworkit/iris";
import React, { FC, useContext } from "react";
import { useTranslation } from "react-i18next";

import { MenuItem, MobileNestedMenu, NestedMenu } from "@/components/Navigation";
import { UserContext } from "@/components/User";
import { ILocation } from "@/data/locations";

import { EWORK_PLUS_LINKS } from "./EworkPlusLinks";

type Props = { variant?: "desktop" | "medium" | "mobile" };

export const EworkPlus: FC<Props> = ({ variant = "desktop" }) => {
  const User = useContext(UserContext);
  const { t } = useTranslation("session");
  const location: ILocation | undefined | null =
    User.contextCompany?.location || User.contextConsultantProfile?.location;
  const countryCode = location?.countryCode || "default";

  const renderMenuItems = () =>
    Object.entries(EWORK_PLUS_LINKS)
      .filter(([category]) => !(category === "Wellness" && ["DNK", "NOR"].includes(countryCode)))
      .map(([category, links]) => (
        <MenuItem
          key={category}
          onClick={() => window.open(links[countryCode] || links.default, "_blank")}
          sx={{ display: "flex", justifyContent: "flex-start", textAlign: "left", width: "100%" }}>
          {category}
        </MenuItem>
      ));

  if (variant === "desktop" || variant === "medium") {
    return (
      <MenuItem
        as={NestedMenu}
        level={1}
        buttonContent={t("COMPONENTS.TOPBAR.BUTTON_COURSES")}
        className={variant == "desktop" ? `navigation--nested` : `navigation--nested--3rd`}>
        {renderMenuItems()}
      </MenuItem>
    );
  }

  if (variant === "mobile") {
    return (
      <MenuItem
        as={MobileNestedMenu}
        size="md"
        buttonContent={t("COMPONENTS.TOPBAR.BUTTON_COURSES")}
        className="navigation--mobile-nested">
        <Flex flexDirection="column">{renderMenuItems()}</Flex>
      </MenuItem>
    );
  }

  return null;
};
